<div class="col-xs-12">
  <div class="m-t-sm m-b-sm" ng-if="funcao.id">
    <historico-alteracoes id="{{funcao.id}}" type="Funcao" />
  </div>
  <div class="btn-group">
    <div class="btn btn-default btn-sm btn-action" ng-click="goToIndex()">Voltar</div>
    <div class="btn btn-primary btn-sm btn-action" ng-click="edit()" ng-if="permissions.funcao.canManage">
      Editar <i class="glyphicon glyphicon-pencil"></i>
    </div>
    <div class="btn btn-danger btn-sm btn-action" ng-click="delete()" ng-if="permissions.funcao.canManage">
      Excluir <i class="glyphicon glyphicon-trash"></i>
    </div>
  </div>
</div>
